var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ripa-header"},[_c('span',{staticClass:"tw-text-base md:tw-text-lg tw-uppercase"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }